module.exports = __webpack_public_path__ + "img/logo.c2808c9c.png";